import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../../contexts/AuthContext';
import { useCarrierOrg } from '../../hooks/useCarrierOrg';
import { carrierApi } from '../../firebase/functionsService';
import { COLORS } from '../../styles/tokens';

// Vises i sjåførens profil i stedet for «Utbetaling og fakturering» når sjåføren kjører for et transportfirma.
export default function CarrierMembershipCard() {
  const navigate = useNavigate();
  const { refreshUserDoc } = useAuth();
  const { orgId, org } = useCarrierOrg();
  const [error, setError] = useState('');
  const [busy, setBusy] = useState(false);

  async function leave() {
    if (!window.confirm(`Forlate ${org?.orgName ?? 'firmaet'}? Du må registrere deg selvstendig for å kjøre for deg selv.`)) return;
    setBusy(true);
    setError('');
    try {
      await carrierApi.leaveCarrierOrg({ orgId });
      await refreshUserDoc();
      navigate('/');
    } catch (err) {
      setError(err.message || 'Kunne ikke forlate firmaet');
      setBusy(false);
    }
  }

  return (
    <section style={styles.card}>
      <div style={styles.title}>Du kjører for {org?.orgName ?? 'et transportfirma'}</div>
      <p style={styles.text}>Firmaet tildeler deg oppdrag og fakturerer kundene. Du trenger ikke egne fakturaopplysninger eller utbetaling.</p>
      {error && <p role="alert" style={styles.error}>{error}</p>}
      <button type="button" style={styles.btn} onClick={leave} disabled={busy}>Forlat firmaet</button>
    </section>
  );
}

const styles = {
  card:  { padding: '14px 16px', borderTop: `1px solid ${COLORS.border}` },
  title: { fontWeight: 700, fontSize: 15, color: COLORS.textDark },
  text:  { fontSize: 13.5, color: COLORS.textMid, lineHeight: 1.5, margin: '6px 0 10px' },
  error: { background: COLORS.dangerBg, color: COLORS.dangerText, padding: '8px 10px', borderRadius: 10, fontSize: 13.5 },
  btn:   { height: 38, padding: '0 16px', borderRadius: 19, border: `1px solid ${COLORS.dangerBorder}`, background: COLORS.dangerBg, color: COLORS.dangerText, fontWeight: 600, cursor: 'pointer' },
};
